import styled from 'styled-components'
import { sizeMobile, gutter } from 'components/globalStyles'

export const MainTitle = styled.h2`
  color: var(--forest);
  padding-bottom: 24px;
  padding-left: ${gutter};
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 32px;
  justify-items: center;
  align-items: center;
  padding: 0 ${gutter};

  @media (max-width: ${sizeMobile}) {
    grid-template-columns: 1fr;
  }
`

export const ArrowContainer = styled.div`
  justify-self: end;
`

export const PaginationContainer = styled.div`
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`
